import { AppRoutes } from './routes';
import { CustomerServiceChat } from '@components/features/CustomerServiceChat';

export default function App() {
  return (
    <>
      <AppRoutes />
      <CustomerServiceChat />
    </>
  );
}
